import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import { FlowSurvey } from "./views/flow_survey";
import { LocalizationWrapper } from "./components/localization_wrapper";
import { apiClient } from "./client";
import { DEFAULT_LOCALE, LOCALES } from "./locales";
import "./assets/stylesheets/index.css";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
    integrations: [],
  });
}

const root = document.getElementById("root");
const params = new URLSearchParams(window.location.search);

const flow = params.get("flow") || root.dataset.flow || "herent";
const street = params.get("street") || root.dataset.street || undefined;

const htmlLang = document.documentElement.lang?.toLowerCase().split("-")[0];
const locale = LOCALES.includes(htmlLang) ? htmlLang : DEFAULT_LOCALE;

const setAppHeight = () => {
  root.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", setAppHeight);
window.addEventListener("blur", setAppHeight);
setAppHeight();

ReactDOM.createRoot(root).render(
  <LocalizationWrapper locale={locale}>
    <FlowSurvey apiClient={apiClient} flow={flow} initialStreet={street} />
  </LocalizationWrapper>,
);
